export default{
    noteRow: {
        index: 'note-row-index',
    }
}
